export default __webpack_public_path__ + "static/media/78.a1ffc66d.jpg";